import { QueryClient } from "@tanstack/react-query"
import type { AxiosError } from "axios"
import type { ProblemDetail } from "@/lib/api-client"

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,          // 1 minute
      gcTime: 5 * 60_000,         // 5 minutes
      retry: (failureCount, error) => {
        const axiosErr = error as AxiosError<ProblemDetail>
        const status = axiosErr?.response?.status
        // Do not retry on auth or client errors
        if (status && status >= 400 && status < 500) return false
        return failureCount < 2
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
})
